import { Navigate, type RouteObject } from "react-router";
import { SetOverviewIndexRoute } from "./[documentationId]/set-overview/_components/set-overview-index-route";
import { DocumentationsIndexRoute } from "./_components/documentations-index-route";
import { DocumentationRoute } from "./[documentationId]/documentation-route";

export const documentationsRoute: RouteObject[] = [
  {
    index: true,
    element: <DocumentationsIndexRoute />,
  },
  {
    path: ":documentationId",
    element: <DocumentationRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="sample-sets" />,
      },
      {
        path: "sample-sets",
        element: <SetOverviewIndexRoute />,
      },
    ],
  },
];
